import { HddUsageModalController } from './hdd-usage-modal.component';

export class HddUsageModalService {
  constructor($modal) {
    this.$modal = $modal;
  }

  show() {
    this.$modal.open({
      template: require('../admin/hdd-usage-modal.component.html'),
      controller : HddUsageModalController,
    })
      .result
      .then(result => {
        //console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/admin/hdd-usage-modal.service.js